import React, { Component } from "react";
import { Helmet } from "react-helmet";
import ReCAPTCHA from "react-google-recaptcha";
import uk from "../images/flag-uk.png";
import sweeden from "../images/flag-sweden.png";
import malta from "../images/flag-malta.png";

let recaptchaInstance;

const resetRecaptcha = () => {
  recaptchaInstance.reset();
};

class Contact extends Component {
  constructor() {
    super();
    this.state = {
      siteKey: "6LeLb3YUAAAAAKE1YY9tyH_35znvoMprmJDCy2ZN",
      Token: "",
      warning: 0,
    };

    this.contactForm = React.createRef();

    this.nameField = React.createRef();
    this.emailField = React.createRef();
    this.phoneField = React.createRef();
    this.companyField = React.createRef();
    this.messageField = React.createRef();
  }

  componentDidMount() {
    resetRecaptcha();
    document.getElementById("root").classList.remove("welcome");
    document.getElementById("root").classList.remove("affiliate");
    document.getElementById("foo").classList.add("overflow");
  }

  verify = (e) => {
    console.log("Google Hash" + e);
    this.setState({ Token: e });
  };

  ///[obsolete]
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  post = (e) => {
    const data = this.state;

    const valid = this.contactForm.current.checkValidity();
    const _self = this;
    if (valid) {
      e.preventDefault();
      this.setState({ loading: true });
      data.FullName = this.nameField.current.value;
      data.Email = this.emailField.current.value;
      data.CompanyName = this.companyField.current.value;
      data.PhoneNumber = this.phoneField.current.value;
      data.Message = this.messageField.current.value;
      data.Token = this.state.Token;
      fetch("https://stech-news.azurewebsites.net/api/ContactFormHttpTrigger", {
        method: "post",
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.Status !== "OK") {
            _self.setState({ warning: 1 });
          } else {
            _self.setState({ warning: 2, done: true, loading: false });
          }
        })
        .catch((err) => console.log(err));
    }
  };

  render() {
    const { siteKey, warning, done } = this.state;
    return (
      <div className="sub-page">
        <Helmet>
          <title>STech - Contact</title>
          <meta name="description" content="STech - Contact pages" />
        </Helmet>
        <header className="clearfix fadeInUp">
          <div className="container">
            <div className="left" />
            <div className="right">
              <h1>Get in Touch</h1>
              <h2>Got a project to discuss?</h2>
            </div>
          </div>
        </header>
        <section className="clearfix fadeInUp">
          <div className="container contact clearfix">
            <div className="left" />
            <div className="right">
              <div className="form-field col ">
                <div
                  className="contact-result-ok"
                  style={{ display: warning === 2 ? "block" : "none" }}
                >
                  Thank you for contacting us.
                  <br />
                  <span>We will be in touch as soon as possible.</span>
                </div>
                <div
                  className="contact-result-nok"
                  style={{ display: warning === 1 ? "block" : "none" }}
                >
                  <span>Please check captcha!</span>
                </div>
              </div>
              <form
                className="contact-form"
                style={{ display: done ? "none" : "block" }}
                action="#!"
                id="contactForm"
                ref={this.contactForm}
              >
                <div className="form-field col">
                  <input
                    id="name"
                    name="FullName"
                    className="input-text js-input"
                    type="text"
                    ref={this.nameField}
                    required
                  />
                  <label className="label" htmlFor="name">
                    Your Full Name
                  </label>
                </div>
                <div className="form-field col">
                  <input
                    id="email"
                    name="Email"
                    className="input-text js-input"
                    type="email"
                    ref={this.emailField}
                    required
                  />
                  <label className="label" htmlFor="email">
                    Email
                  </label>
                </div>
                <div className="form-field col">
                  <input
                    id="company"
                    name="CompanyName"
                    className="input-text js-input"
                    ref={this.companyField}
                    type="text"
                    required
                  />
                  <label className="label" htmlFor="company">
                    Your Company Name
                  </label>
                </div>
                <div className="form-field col">
                  <input
                    id="phone"
                    name="PhoneNumber"
                    className="input-text js-input"
                    ref={this.phoneField}
                    type="text"
                    required
                  />
                  <label className="label" htmlFor="phone">
                    Phone Number
                  </label>
                </div>
                <div className="form-field col">
                  <textarea
                    id="message"
                    className="input-text js-input"
                    name="message"
                    form="usrform"
                    ref={this.messageField}
                    required
                  />
                  <label className="label" htmlFor="message">
                    What would you like to talk about?
                  </label>
                </div>
                <div className="form-field col align-center">
                  <ReCAPTCHA
                    ref={(e) => (recaptchaInstance = e)}
                    sitekey={siteKey}
                    onChange={(response) => this.verify(response)}
                  />
                </div>
                <div className="form-field col align-center">
                  <div className="form-button">
                    {this.state.loading ? <span class="load open" /> : null}
                    <input
                      className="btn"
                      type="submit"
                      value="Submit"
                      onClick={this.post}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>

        <section className="clearfix adress fadeInUp">
          <div className="container">
            <h1>Find us here</h1>
            <ul className="row">
              <li>
                <div className="flex">
                  <img src={uk} title="United Kingdom" alt="United Kingdom" />
                  <h3>United Kingdom</h3>
                </div>
                <p>
                  <strong>Here is our head office</strong> <br />
                  South Quay Building, 77 Marsh Wall, London, England, E14 9SH
                  <br />
                  <br />
                </p>
              </li>
              <li className="hide">
                <div className="flex">
                  <img src={sweeden} title="Sweden" alt="Sweden" />
                  <h3>Sweden</h3>
                </div>
                <p>
                  90 Tottenham Court Road <br />
                  London W1T 4TJ, United Kingdom <br />
                  <br />
                  P: +44 207 323 3888
                </p>
              </li>
              <li className="hide">
                <div className="flex">
                  <img src={malta} title="Malta" alt="Malta" />
                  <h3>Malta</h3>
                </div>
                <p>
                  90 Tottenham Court Road <br />
                  London W1T 4TJ, United Kingdom <br />
                  <br />
                  P: +44 207 323 3888
                </p>
              </li>
            </ul>
          </div>
        </section>
      </div>
    );
  }
}

export default Contact;
